import jwt from '../../http/requests/auth/jwt/index.js';

import 'firebase/auth';
import axios from '@/axios';

export default {
   getAllCategory(_context, data){
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/non-auth/categories', { params: data })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  addCategory(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .saveHttpCategory(data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  getParentCategoryList() {
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpParentCategoryList()
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  getPopularCategory() {
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpPopularCategory()
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  getCategoryList(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpCategoryList(data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  getSubCategoryList(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpSubCategoryList(data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  getCategoryDetails(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpCategoryDetails(data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  getCategoryDetailsBySlug(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpCategoryDetailsBySlug(data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },

  updateCategoryDetails(_context,data){
    return new Promise((resolve,reject)=>{
      jwt
        .updateHttpCategoryDetail(data)
        .then((res) => {
          resolve(res);
        }).catch(err =>{
        reject(err);
      });
    });
  },
  getCategoryProductList(_context,data){
    return new Promise((resolve,reject)=>{
      jwt
        .fetchHttpProductListByCategory(data.dataTableParams, data.id)
        .then((res) => {
          resolve(res);
        }).catch(err =>{
        reject(err);
      });
    });
  },
  deleteCategoryById(_context,id){
    return new Promise((resolve, reject) => {
      jwt
        .deleteHttpCategory(id)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  removeProductFromCategory(_context,data){
    return new Promise((resolve, reject) => {
      jwt
        .deleteHttpProductFromCategory(data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },

  updateMenuParentCategories( {commit}, categories ){
    commit('SET_PARENT_CATEGORIES', categories);
  },

  
};
